import Vue from "vue";
import { Component } from "vue-property-decorator";
import * as icons from "@/components/icons";
import {
    IGlobalSettings,
} from "@/models";

@Component({
    name: "global",
    components: {
        "save-icon": icons.SaveIcon,
    },
})

export default class Global extends Vue {
    public loadPromises: Array<Promise<any>>;

    constructor() {
        super();

        this.loadPromises = [];

        if (!this.$store.state.request.globalSettings) {
            this.loadPromises.push(this.$store.dispatch("request/fetchGlobalSettings"));
        }
    }

    public get globalSettings(): IGlobalSettings {
        return this.$store.getters["request/getGlobalSettings"];
    }

    public async saveGlobalSettings(): Promise<void> {
        await this.$store.dispatch("request/saveGlobalSettings", this.globalSettings);
    }
}
